/**
 * 商品消费冲调
 */
import http from './http';

// 获取商品消费明细
export const getGoodsBillDetail = (billNo) => {
  return http({
    method: 'POST',
    url: `/bill/billConsumptionDetail/${billNo}`,
  });
};

// 冲调提交
export const submitGoodsReversal = (data) => {
  return http({
    method: 'POST',
    url: '/bill/returnBrew',
    data,
  });
};
